<template>
  <div class="page">
    <div class="top">
      <span class="back" @click="back">返回首页</span>
    </div>
    <div class="status">
      <div class="animation-wrapper">
        <lottie :options="gif" />
      </div>
      <h1>系统繁忙，请重新提现</h1>
      <h2 class="description">
        抱歉，由于系统异常导致放款失败，
        <br/>
        您可重新发起提现申请；如有疑问联系客服。
        <br/>
      </h2>
    </div>
    <div class="round-block">
      <div class="title">现平台为您匹配更多高通过率资方</div>
      <div class="desc">再次提现通过率</div>
      <div class="bottom">
        <span>98%</span>
        <div class="right">跑赢{{result.rejectAgainProbability}}%平台用户</div>
      </div>
    </div>
    <nd-button @click="reWithdraw">重新提现</nd-button>
    <call-service-button
      class="call"
      @onCall="callService"
    />
  </div>
</template>

<script>
import Lottie from 'vue-lottie'
import { fail } from '@/assets/json/index'
import callServiceButton from '@/components/service-button'

export default {
  props: {
    result: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Lottie,
    callServiceButton
  },
  data () {
    return {
      gif: {
        animationData: fail,
        loop: false
      }
    }
  },
  methods: {
    reWithdraw () {
      // *额度有效，跳转至【我要提现】页面，否则跳转至首页，与外层confirm方法一致
      this.$emit('onReWithdraw')
    },
    callService () {
      this.$emit('onCall')
    },
    back () {
      this.backHome()
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  height: 100%;
  .top {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    padding:30px 15px;
    margin-bottom: 30px;
    padding-top: 128px;
    .back {
      float: right;
      text-decoration: underline;
      text-align: right;
    }
  }
  .status {
    .animation-wrapper {
      height: 210px;
      width: 210px;
      margin: 0 auto;
    }
    h1 {
      font-family: PingFangSC-Medium,PingFang SC;
      font-weight: 500;
      font-size: 42px;
      margin-top: 50px;
      line-height: 59px;
      text-align: center;
      color:333333;
    }
    h2 {
      font-family: 'PingFangSC-Regular';
      font-weight: 400;
      font-size: 28px;
      line-height: 36px;
      margin: 0 57px;
      margin-top: 20px;
    }
    .description {
      margin: 0;
      width: 100%;
      padding: 0 63px;
      color: rgba(102,102,102,1);
      margin-top: 15px;
      font-size: 26px;
      text-align: center;
    }
  }
  .round-block {
    width: 610px;
    height: 230px;
    background: #FFF6ED;
    margin: 0 auto;
    margin-top: 50px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #994B24;
    padding: 40px 40px 24px;
    .title {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      line-height: 45px;
    }
    .desc {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 40px;
      margin-top: 10px;
    }
    .bottom {
      font-size: 60px;
      font-family: DIN-Medium, DIN;
      font-weight: 500;
      color: #FF4633;
      line-height: 73px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .right {
        width: 304px;
        height: 43px;
        background: url(../image/img_background_leading@2x.png) no-repeat center center;
        background-size: contain;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #752700;
        line-height: 43px;
        text-align: center;
      }
    }
  }
  .nd-button {
    width: 320px;
    height: 80px;
    line-height: 80px;
    margin: 40px auto 0;
  }
  .call {
    position: absolute;
    bottom: 140px;
    left: 275px;
  }
}
</style>